<template>
  <div class="app-pagination mt-3">
    <button class="btn btn-secondary" @click="goToPage(normalizedCurrentPage - 1)" :disabled="normalizedCurrentPage === 1">Anterior</button>
    <button
      v-for="item in visibleItems"
      :key="item.key"
      class="btn"
      :class="item.type === 'ellipsis'
        ? 'btn-outline-secondary pagination-ellipsis'
        : item.page === normalizedCurrentPage
          ? 'btn-dark'
          : 'btn-outline-secondary'"
      @click="item.type === 'page' ? goToPage(item.page) : null"
      :disabled="item.type === 'ellipsis' || item.page === normalizedCurrentPage"
    >
      {{ item.label }}
    </button>
    <button class="btn btn-secondary" @click="goToPage(normalizedCurrentPage + 1)" :disabled="normalizedCurrentPage === normalizedTotalPages">Siguiente</button>
  </div>
</template>
  
  <script>
  export default {
    name: 'AppPagination',
    props: { currentPage: { type: Number, required: true }, totalPages: { type: Number, required: true } },
    computed: {
      normalizedCurrentPage() {
        const current = Number(this.currentPage) || 1;
        return Math.min(Math.max(current, 1), this.normalizedTotalPages);
      },
      normalizedTotalPages() {
        return Math.max(Number(this.totalPages) || 1, 1);
      },
      visibleItems() {
        const total = this.normalizedTotalPages;
        const current = this.normalizedCurrentPage;

        if (total < 5) {
          return Array.from({ length: total }, (_, index) => {
            const page = index + 1;
            return { type: 'page', page, label: String(page), key: `page-${page}` };
          });
        }

        if (total === 5) {
          if (current <= 2) {
            return [
              { type: 'page', page: 1, label: '1', key: 'page-1' },
              { type: 'page', page: 2, label: '2', key: 'page-2' },
              { type: 'ellipsis', label: '...', key: 'ellipsis-2-5' },
              { type: 'page', page: 5, label: '5', key: 'page-5' }
            ];
          }

          if (current >= 4) {
            return [
              { type: 'page', page: 1, label: '1', key: 'page-1' },
              { type: 'ellipsis', label: '...', key: 'ellipsis-1-4' },
              { type: 'page', page: 4, label: '4', key: 'page-4' },
              { type: 'page', page: 5, label: '5', key: 'page-5' }
            ];
          }

          return [
            { type: 'page', page: 1, label: '1', key: 'page-1' },
            { type: 'ellipsis', label: '...', key: 'ellipsis-1-3' },
            { type: 'page', page: 3, label: '3', key: 'page-3' },
            { type: 'ellipsis', label: '...', key: 'ellipsis-3-5' },
            { type: 'page', page: 5, label: '5', key: 'page-5' }
          ];
        }

        const pages = new Set([1, 2, total - 1, total, current]);
        const orderedPages = Array.from(pages)
          .filter((page) => page >= 1 && page <= total)
          .sort((a, b) => a - b);

        const items = [];
        orderedPages.forEach((page, index) => {
          const previous = orderedPages[index - 1];
          if (index > 0 && page - previous > 1) {
            items.push({
              type: 'ellipsis',
              label: '...',
              key: `ellipsis-${previous}-${page}`
            });
          }

          items.push({
            type: 'page',
            page,
            label: String(page),
            key: `page-${page}`
          });
        });

        return items;
      }
    },
    methods: {
      goToPage(page) {
        if (page < 1 || page > this.normalizedTotalPages) return;
        this.$emit('page-changed', page);
      }
    }
  };
  </script>
  
<style scoped>
.app-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  min-width: 0;
}

.app-pagination .btn {
  flex: 0 1 auto;
  min-width: 0;
}

.pagination-ellipsis {
  pointer-events: none;
}

@media (max-width: 576px) {
  .app-pagination {
    justify-content: stretch;
  }

  .app-pagination .btn {
    flex: 1 1 calc(33.333% - 0.5rem);
  }
}
</style>
  
